import {RequestEntity} from "../types/RequestEntity";
import {EquipmentRequestEntity} from "../../../../graphql/graphQlApiHooks";

export const isSingleRequest = (entity: RequestEntity): entity is EquipmentRequestEntity => entity?.__typename === 'EquipmentRequestEntity';
